import "../style.scss";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { Toaster } from "react-hot-toast";
import useCustomToast from "../../../../hooks/useCustomToast";
import LayoutProvider from "../../../../providers/LayoutProvider";
import { getGroupbyId, getGroups, getUserbyId, updateUser } from "../../../../components/Axios/Axios";
function EditUser() {

    const [userName, setUserName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [staff, setStaff] = useState(false);
    const [superUser, setSuperUser] = useState(false);
    const [role, setRole] = useState("")
    const [selectedGroupptions, setSelectedGroupOptions] = React.useState<any>([]);
    const [groupOptions, setGroupOptions] = React.useState<any>([])
    const { id }: any = useParams();

    const handleMultiSelectCrewChange = (selected: any) => {
        console.log(selected);
        setSelectedGroupOptions(selected);
    };

    const customToast = useCustomToast();

    const handleStaff = (event: any) => {
        setStaff(!staff);
        console.log(staff);
    };
    const handleSuperuser = (event: any) => {
        setSuperUser(!superUser);
        console.log(superUser);
    };

    const handleChangeUser = (e: any) => {
        const { name, value, type } = e.target;
        setRole(value)
    };

    // get Group Lookups
    const getLookups = async () => {
        try {
            const data = await getGroups();
            console.log("groups", data.data);

            const formattedData = data.data.map((item: { name: any; _id: any; }) => ({
                value: `${item.name}`,
                label: `${item.name}`,
                id: item._id,
                name: item.name,
            }));

            setGroupOptions(formattedData);

            console.log(groupOptions);
        } catch (error) {
            console.error("Error adding flight", error);
        }
    };

    React.useEffect(() => {
        getLookups();
    }, []);

    // get user data
    const fetchUserData = async () => {
        try {
            const data = await getUserbyId(id);
            console.log("user", data)
            setUserName(data.username)
            setFirstName(data.firstname)
            setLastName(data.lastname)
            setEmail(data.email)
            setStaff(data.isStaff)
            setSuperUser(data.isSuperuser)
            setRole(data.role);
            const groupNames = [];

            for (let i = 0; i < data.groups.length; i++) {
                const groupData = await getGroupbyId(data.groups[i]);
                groupNames.push(groupData);
            }
            const formattedData = groupNames.map((item: { name: any; _id: any; }) => ({
                value: `${item.name}`,
                label: `${item.name}`,
                id: item._id,
                name: item.name,
            }));
            setSelectedGroupOptions(formattedData);

        } catch (error) {
            console.error("erroring fetching user data", error);
        }
    };

    React.useEffect(() => {
        fetchUserData();
    }, []);

    //Update function
    const onSubmitForm = async (e: any) => {
        e.preventDefault();

        let success = false;
        const selectedGroups = selectedGroupptions.map((selectedOption: any) => selectedOption.id);

        const data2 = {
            username: userName,
            firstname: firstName,
            lastname: lastName,
            email: email,
            isStaff: staff,
            isSuperuser: superUser,
            groups: selectedGroups,
            // role: role
        };

        console.log(data2, "body1 Payload");

        try {
            await updateUser(id, data2);
            success = true;
        } catch (error) {
            console.error("Error updating user:", error);
        }

        if (success) {
            customToast("User updated successfully", "success");
        } else {
            customToast("Failed to update user", "error");
        }
    };


    return (
        <LayoutProvider>
            <h6 className="dashboard_subheading">Dashboard {">"} Edit User</h6>
            <section
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <h4 className="dashboard_heading">Edit User</h4>
            </section>
            <div style={{ width: '100%' }}></div>
            <div className="auth__page">
                <Toaster />
                <div className="left" style={{ padding: "0px" }}>
                    <form className="form-wrapper" onSubmit={onSubmitForm}>
                        <label className="form-label">UserName</label>
                        <input
                            type="text"
                            placeholder="Enter your Username"
                            className="input"
                            name="username"
                            value={userName}
                            onChange={e => setUserName(e.target.value)}
                            required
                        />
                        <div className="d-flex gap-3">
                            <div className="form_group" style={{ width: "50%", marginTop: "2%" }}>
                                <label className="form-label">First Name</label>
                                <input
                                    type="text"

                                    placeholder="David"
                                    className="input"
                                    name="firstname"
                                    value={firstName}
                                    onChange={e => setFirstName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form_group" style={{ width: "50%", marginTop: "2%" }}>

                                <label className="form-label">Last Name</label>
                                <input
                                    type="text"

                                    placeholder="Smith"
                                    className="input"
                                    name="lastname"
                                    value={lastName}
                                    onChange={e => setLastName(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: "2%" }}>
                            <label className="form-label">Email</label>
                            <input
                                type="text"
                                placeholder="Enter Email"
                                className="input"
                                name="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div style={{ marginTop: "2%" }}>
                            <label className="form-label">Groups</label>
                            <Select
                                isMulti
                                options={groupOptions}
                                value={selectedGroupptions}
                                onChange={handleMultiSelectCrewChange}
                                placeholder="Select Permissions"
                                name={"groups"}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        marginBottom: "2%",
                                        maxWidth: "100%",
                                        fontSize: "1rem",
                                        fontWeight: "400",
                                        lineHeight: "1.5",
                                        height: "40px ",

                                    }),
                                    clearIndicator: () => ({ display: "none" }), // Hide the clear indicator (X icon)
                                }}
                            />
                        </div>
                        <div className="d-flex gap-3">
                            <div className="checkbox_input">
                                <input
                                    type="checkbox"
                                    name="staff"
                                    checked={staff}
                                    onChange={handleStaff}
                                />
                                <label className="heading4">
                                    Staff
                                </label>
                            </div>
                            <div className="checkbox_input">
                                <input
                                    type="checkbox"
                                    name="superuser"
                                    checked={superUser}
                                    onChange={handleSuperuser}
                                />
                                <label className="heading4">
                                    SuperUser
                                </label>
                            </div>
                            <div className="checkbox_input">
                                <input
                                    type="checkbox"
                                    name="student"
                                    checked={role === "student"}
                                    value={"student"}
                                    onChange={handleChangeUser}
                                />
                                <label className="heading4">
                                    Student
                                </label>
                            </div>
                            <div className="checkbox_input">
                                <input
                                    type="checkbox"
                                    name="staff"
                                    checked={role === "instructor"}
                                    onChange={handleChangeUser}
                                    value={"instructor"}
                                />
                                <label className="heading4">
                                    Instructor
                                </label>

                            </div>
                        </div>
                        <div className="d-flex justify-content-end" > <button className="button" >
                            Update
                        </button></div>
                    </form>
                </div>

            </div>
        </LayoutProvider>
    );
}

export default EditUser;
